export default {
    namespaced: true,
    pbx_call: {
      title: "Call | Calls",
      uuid: "UUID",
      status: "status",
      caller: "caller",
      receiver: "receiver",
      started_at: "started at",
      ended_at: "ended at",
      recording: "recording",
    },
  };
  